module.exports = __webpack_public_path__ + "img/imgYLSYB(11).fa5a9caf.png";